import { render, staticRenderFns } from "./StatusRel.vue?vue&type=template&id=acacb1ae"
import script from "./StatusRel.vue?vue&type=script&lang=js"
export * from "./StatusRel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports